<template>
  <div class="kr-layout-content">
    <!--专题列表-->
    <ul class="act-list">
      <li v-for="(item,index) in content" :key="index" @click=" speDetails(item.id,item.pic)">
        <div class="act-img">
          <img :src="item.pic" alt />
        </div>
        <div class="act-cont">
          <p class="title">{{item.title}}</p>
          <p class="art twoline">{{item.des}}</p>
        </div>
      </li>
    </ul>
    <div v-if="loadmore" class="look-more" @click="newsMore">查看更多</div>
    <p v-if="!loadmore" class="none-more">没有更多了</p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      content: [],
      loadmore:true,
      curPage: 1,
      totalPage: 0,
    };
  },
  methods: {
    getData() {
      this.$http
        .get("/api/core/015--zhuanTiList",{
          params: {
            pageNo: this.curPage,
            limit:9
          }
        })
        .then(res => {
          // console.log(res, "专题页列表");
          if (res.status == 200 && res.data.code == 0) {
            this.content = this.content.concat(res.data.rows);
            if (this.curPage >=  res.data.totalPage) {
              this.loadmore = false;
            }
            this.curPage ++;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    newsMore() {  //查看更多
      this.getData();
    },
    speDetails(id,imgUrl) {
      //专题图文详情
      this.$router.push({ path: "/specialList", query: { id: id, imgUrl: imgUrl }});
    },
  },
  created() {
    this.getData();
  }
};
</script>
<style scoped>
.new-article .art-list li .content .author .name {
  padding-left: 0px;
}

.look-more {
  margin: 60px auto;
}

.act-list {
  width: 102%;
}
.act-list li {
  cursor: pointer;
  box-sizing: border-box;
  border: 10px solid #fff;
}
.act-list li .act-cont{
  background: #eaf2ec;
}
.act-list li:hover {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
}

.act-list li .act-cont {
  box-shadow: none;
}

.act-list li .act-img:hover img {
  transform: scale(1.1, 1.1);
  transition: all 0.6s;
}
@media (min-width: 1280px) and (max-width: 1366px){
  .act-list li{width:31%;height:290px;margin:0px 10px 15px 0px;}
}
@media (min-width: 1100px) and (max-width: 1279px){
.act-list li{height:250px;margin:0px 10px 15px 0px;}
}
@media (min-width: 800px) and (max-width: 1099px){
.act-list li{width:48%;height:250px;margin:0px 10px 15px 0px;}
}
@media (min-width: 720px) and (max-width: 799px){
.act-list li{width:47%;height:250px;margin:0px 10px 15px 0px;}
}
@media (min-width: 640px) and (max-width: 719px){
.act-list li{width:47%;height:250px;margin:0px 10px 15px 0px;}
}
@media (max-width: 639px) and (min-width: 415px){
  .act-list li{width:47%;height:235px;margin:0px 10px 15px 0px;}
}
@media (min-width: 320px) and (max-width: 414px){
  .act-list {padding-left:0px;}
  .act-list li{margin:0px}
}
</style>